import { useEffect, useState } from "react";
import { MonitorFaturamentoService } from "../../../../services";
import { responseErros } from "../../../../utils";
import MonitorFatCard from "./monitor-fat-card.view";
import MonitorFatRankingBarra from "./monitor-fat-ranking-barra.view";

const monitorFaturamentoService = new MonitorFaturamentoService();

function MonitorFatRankingClientes({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    buscarRankingClientes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscarRankingClientes() {
    setLoading(true);
    const result = await monitorFaturamentoService.rankingClientes(filtrosBody);
    if (!result.isAxiosError) {
      setRows(result.data || []);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const itens = rows.map((r) => ({
    key: r.clienteId,
    label: r.nome,
    valor: r.valor,
  }));

  return (
    <MonitorFatCard
      titulo="Ranking de Clientes por Faturamento"
      icone="ph-users"
      loading={loading}
    >
      <MonitorFatRankingBarra itens={itens} corBarra="#7b1fa2" />
    </MonitorFatCard>
  );
}

export default MonitorFatRankingClientes;
